import React, { useEffect, useState } from "react"
import { useAuth } from "../../hooks/auth"
import { useTranslation } from 'react-i18next'
import Select from "./Select"
import UserApi from "../../services/UserApi"
import { strSemAcentos } from "../../utils/componentUtils"

type ComboProps = any;

//includeFCAUsers / includeSupplierUsers - usuarios fornecedor nao tem username, entao se nao for listar, filtra-se por networklogin = null
const SelectUser: React.FC<ComboProps> = ({ name, control, multiple, style, label, onChange, onKeyUp, inputRef, includeFCAUsers = true, includeSupplierUsers = true}) => {
  const { user } = useAuth()
  const { t: _t } = useTranslation("General")
  const [userList, setUserList] = useState<any>([])
  
  useEffect(() => {
    UserApi.getUsers()
        .then(response => {
          setUserList(response.data
            .filter((el: { networkLogin: any}) => { return (includeFCAUsers && el.networkLogin !== null) || (includeSupplierUsers && el.networkLogin === null); } )
            .map((element: { networkLogin: any; name: any, email: any }) => ({
              code: element.networkLogin ? element.networkLogin : element.email,
              label: element.name
            })))
              
        });
  }, []) 

  //Exibir apenas 10 itens, permitindo a busca ao digitar
  const handleSearch = async (val: string) => {
    let users = userList.filter((item:any) => strSemAcentos(item.code + item.label).toUpperCase().indexOf(val.toUpperCase()) >= 0);
    
    return users.slice(0, 10);
  };

  return (
    <Select 
      allowSelectValueNotFound={false}
      label={label} 
      name={name}
      control={control} 
      options={userList}
      searchFunction={handleSearch}
      showDefailedOptions={true}
      allowCodeSearch={true}
      multiline={multiple}
      onChange={onChange}
      onKeyUp={onKeyUp}
      inputRef={inputRef}
      style={style ? style : {width: '100%'}}/>
  )
}

export default SelectUser
